import { useMemo } from 'react'
import { State } from '~models/consultation/types'
import useMyConsultations from '~repositories/hooks/use-my-consultations'
import ConsultationCardWithProfile from './components/consultation-card-with-profile'
import LoadMoreButton from './components/load-more-button'

const MyConsultations = () => {
  const { data, isFetchingNextPage, fetchNextPage, hasNextPage } = useMyConsultations({
    states: [State.Pending, State.Occupied, State.Answered, State.Additional, State.Closed],
  })

  const flatData = useMemo(() => data?.pages.flatMap(page => page.results) ?? [], [data])

  /**
   * @TODO: 신규 요소가 load 될 때 birth animation 추가
   * 1. isFetchingNextPage 체크해서 처리하면 될 듯
   */
  return (
    <main className="flex flex-col min-h-full">
      {flatData.map(item => (
        <div className="w-full border-b-[1px] border-gray-300 dark:border-gray-900" key={item.id}>
          <ConsultationCardWithProfile consultation={item} />
        </div>
      ))}
      <LoadMoreButton
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        buttonType="text"
      />
    </main>
  )
}

export default MyConsultations
